import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, useHistory, Switch } from 'react-router-dom';
import { CustomLayout, RoleBasedRoute } from './components';
import { getDictionary } from './actions';
import { Home, Login, Profile, Error, Registration, ControlPanel, PassExam } from './pages';
import Questions from './pages/control-panel/questions';
import NotFound from './pages/error/not-found';
import { Context } from './defaults';
import './index.css';
import MobileUser from './pages/error/mobile-user';

const App = () => {
  const [dictionary, setDictionary] = useState();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [links, setLinks] = useState([]);
  const [mobileUser, setMobileUser] = useState(false);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') ?? 'kaz';
  });
  const [storageCheckExam, setStorageCheckExam] = useState();

  const logOut = () => {
    setToken(undefined);
    localStorage.removeItem('token');
    history.push('/login');
  };

  useEffect(() => {
    setLoading(true);
    getDictionary()
      .then((res) => res.json())
      .then((res) => {
        const mapped = res.reduce(function (map, obj) {
          map[obj.attributeName] = {
            eng: obj.eng,
            kaz: obj.kaz,
            rus: obj.rus,
          };
          return map;
        }, {});
        setDictionary(mapped);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
        navigator.userAgent,
      )
    ) {
      setMobileUser(true);
    } else setMobileUser(false);

    if (window.innerWidth <= 768) {
      setMobileUser(true);
    }
  }, []);

  return (
    <>
      <BrowserRouter>
        <Context.Provider
          value={{
            dictionary,
            history,
            language,
            loading,
            links,
            setLinks,
            setLoading,
            setLanguage,
            token,
            setToken,
            logOut,
            storageCheckExam,
            setStorageCheckExam,
          }}>
          {mobileUser ? (
            <MobileUser />
          ) : (
            <CustomLayout>
              <Switch>
                <Route exact path="/" component={Home} />
                <Route path="/login" component={Login} />
                <Route path="/registration" component={Registration} />
                <Route path="/error" component={Error} />
                <Route path="/profile" component={Profile} />
                <RoleBasedRoute path="/questions" component={Questions} roles={['teacher']} />
                <RoleBasedRoute path="/pass-exam" component={PassExam} roles={['student']} />
                <RoleBasedRoute
                  path="/control-panel"
                  component={ControlPanel}
                  roles={['admin', 'teacher', 'director', 'student']}
                />
                <Route path="*" exact component={NotFound} />
              </Switch>
            </CustomLayout>
          )}
        </Context.Provider>
      </BrowserRouter>
    </>
  );
};

export default App;
